export default __webpack_public_path__ + "static/media/chat-active.39700772.svg";